import { HighlightsFields, HighlightsProps } from "../types/Highlights.types"

export class HighlightsModel {
  private readonly fields?: HighlightsFields
  constructor(props: HighlightsProps) {
    this.fields = props.fields;
  }
}
